import { Col, Form, Input, Row } from "antd";
import { AutoComplete } from "../../../core/component";
import { translate } from "../../../core";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { CityAndCountryAndStateQueryResponse } from "../../shared/type";
import { GetAllCitiesAndCountriesAndStates } from "../../shared/graphql/location-queries.graphql";

export const AppraisalFormAddress = () => {
  const [cities, setCities] = useState<string[]>([]);
  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [getAllCitiesAndCountriesAndStates] =
    useLazyQuery<CityAndCountryAndStateQueryResponse>(
      GetAllCitiesAndCountriesAndStates
    );

  const fetch = async () => {
    const { data } = await getAllCitiesAndCountriesAndStates();
    const cityList = (data?.cityList ?? []).map((c) => c.name);
    const countryList = (data?.countryList ?? []).map((c) => c.name);
    const states = (data?.statesFind?.data ?? []).map((s) => s.key);

    setCities(cityList);
    setCountries(countryList);
    setStates(states);
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Row gutter={[10, 10]} className="mt-3">
        <Col span={12}>
          <Form.Item
            name={["customerAddress", "street"]}
            label={translate("street")}
            className="w-100"
          >
            <Input  size='middle'/>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={["customerAddress", "line1"]}
            label={translate("line", "1")}
            style={{width: '100%'}}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={["customerAddress", "line2"]}
            label={translate("line", "2")}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[10, 10]} className="mt-3">
        <Col span={6}>
          <Form.Item
            label={translate("city")}
            name={["customerAddress", "city"]}
          >
            <AutoComplete items={cities} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={translate("state")}
            name={["customerAddress", "state"]}
          >
            <AutoComplete items={states} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={translate("country")}
            name={["customerAddress", "country"]}
          >
            <AutoComplete items={countries} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={["customerAddress", "zipCode"]}
            label={translate("zip_code")}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
